import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "making-updates-to-formation"
    }}>{`Making updates to formation`}</h2>
    <p>{`You can find a detailed guide on contributing to formation at `}<a parentName="p" {...{
        "href": "https://dev-design.va.gov/documentation/contributing-to-formation"
      }}>{`https://dev-design.va.gov/documentation/contributing-to-formation`}</a></p>
    <h2 {...{
      "id": "publishing-module-to-npm"
    }}>{`Publishing Module to NPM`}</h2>
    <p>{`After you've tested and previewed your changes locally it's time to publish a new version of the package to NPM.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Prerequisite: you must be `}<a parentName="p" {...{
          "href": "https://docs.npmjs.com/getting-started/publishing-npm-packages"
        }}>{`registered`}</a>{` with NPM, be a member of the "department-of-veterans-affairs" organization, and have the appropriate organization role to publish an update to the module. Verify that you are logged in correctly by running `}<inlineCode parentName="p">{`npm whoami`}</inlineCode>{`. If you are unable to publish an update, confirm you are a member of the "department-of-veterans-affairs" organization by going to your Profile page on `}<a parentName="p" {...{
          "href": "https://www.npmjs.com"
        }}>{`npmjs.com`}</a>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "1-submit-your-pr"
    }}>{`1. Submit your PR`}</h3>
    <p>{`Submit a PR that includes all of your code changes. This should include the bump in versions you need, which you can change directly in the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` files for the modules that are changing.`}</p>
    <p>{`You'll need to choose what type of version update to make:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`patch`}</inlineCode>{` - for bug fixes and minor changes`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`minor`}</inlineCode>{` - for new features that don't break current features or require changes in consuming applications`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`major`}</inlineCode>{` - for backwards breaking changes`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you are unsure of what to pick, do a major version update on modules that are changing.`}</p>
    </blockquote>
    <h3 {...{
      "id": "2-merge-your-pr-to-master"
    }}>{`2. Merge your PR to master`}</h3>
    <p>{`Once your changes are approved, squash merge them to master. Also, if your change is a breaking change, please prefix your commit message with `}<inlineCode parentName="p">{`BREAKING CHANGE: `}</inlineCode>{`. Also keep in mind that your commit messages will be in a changelog that people use to figure out what has changed between releases, so make sure it accurately describes your changes.`}</p>
    <h3 {...{
      "id": "3-build-and-publish"
    }}>{`3. Build and publish`}</h3>
    <ul>
      <li parentName="ul">{`Checkout the master branch`}</li>
      <li parentName="ul">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ul">{`For each module you need to publish, switch to its folder in `}<inlineCode parentName="li">{`packages/`}</inlineCode>{` and run `}<inlineCode parentName="li">{`npm publish`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "4-create-a-release"
    }}>{`4. Create a release`}</h3>
    <p>{`You will need a github `}<a parentName="p" {...{
        "href": "https://help.github.com/en/articles/creating-a-personal-access-token-for-the-command-line"
      }}>{`personal access token`}</a>{`.
This should be set as `}<strong parentName="p">{`GITHUB_API_KEY`}</strong>{` in your environment variable.`}</p>
    <ul>
      <li parentName="ul">{`Navigate to the package folder`}</li>
      <li parentName="ul">{`Run the release script`}
        <pre parentName="li"><code parentName="pre" {...{}}>{`$ yarn release
`}</code></pre>
      </li>
      <li parentName="ul">{`Once the script has succeeded, go to the link provided in the console`}</li>
      <li parentName="ul">{`Edit the release and add any relevant information.`}</li>
    </ul>
    <h3 {...{
      "id": "5-update-consuming-apps"
    }}>{`5. Update consuming apps`}</h3>
    <p>{`The last step is to update the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` files of consuming apps to use the latest version of `}<inlineCode parentName="p">{`@department-of-veterans-affairs/formation`}</inlineCode>{`. For example, if you are working with the `}<inlineCode parentName="p">{`vets-website`}</inlineCode>{` project, open the `}<inlineCode parentName="p">{`vets-website`}</inlineCode>{`'s `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` to update the version number of the `}<inlineCode parentName="p">{`@department-of-veterans-affairs/formation`}</inlineCode>{` entry listed in the `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` section. The version number should match what you just published to NPM.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      